var React = require('react');

function Search (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33 18c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C3 9.716 9.716 3 18 3c8.284 0 15 6.716 15 15zm-3.376 13.744A17.928 17.928 0 0118 36C8.059 36 0 27.941 0 18S8.059 0 18 0s18 8.059 18 18c0 4.43-1.6 8.486-4.255 11.622L47.562 45.44a1.5 1.5 0 11-2.122 2.122L29.624 31.744z"}));
}

Search.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Search;

Search.default = Search;
